import React from 'react';

import { useTheme } from 'styled-components';
import { ColorPalette } from 'theme/colors';
import { ThemeType } from 'theme/theme';

import useStoreTranslation from 'hooks/useStoreTranslation';

import { InfoContainer, IconContainer, Content, Title, Value } from './styles';

export interface Props {
  icon?: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  title: string;
  value?: string;
}

const ProfileInfo = ({ icon: Icon, title, value }: Props) => {
  const { t } = useStoreTranslation();
  const active = !!value;
  const theme = useTheme() as ThemeType;
  return (
    <InfoContainer>
      <IconContainer>
        {Icon && <Icon color={active ? theme.primaryBackgroundColor : ColorPalette.HEX.Manatee} />}
      </IconContainer>
      <Content>
        <Title $active={active}>{title}</Title>
        <Value $active={active}>{value || t('profileInfo.noInfo')}</Value>
      </Content>
    </InfoContainer>
  );
};

export default ProfileInfo;
